import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el UltraPack después de comprarlo?',
  a: 'El UltraPack es 100% digital. Apenas se acredita el pago, recibís un correo electrónico con acceso inmediato para descargar los 6 tomos y los 6 bonos desde cualquier celular, tablet o computadora.'
}, {
  q: '¿Para qué edad es el UltraPack?',
  a: 'Está diseñado para acompañar el desarrollo del habla desde los 0 hasta los 3 años, con 6 tomos organizados por etapas para que siempre sepas qué actividad hacer según la edad de tu hijo.'
}, {
  q: '¿Necesito tener experiencia en estimulación o ser profesional?',
  a: 'No. El UltraPack fue creado para madres y padres, no para especialistas. Solo tenés que seguir las actividades paso a paso.'
}, {
  q: '¿Cuánto tiempo necesito por día?',
  a: 'Solo 10 minutos al día. Las actividades están pensadas para integrarse fácilmente a la rutina, sin materiales costosos ni preparaciones complicadas.'
}, {
  q: '¿Y si mi hijo ya tiene más de 18 meses?',
  a: 'También sirve. El sistema incluye tomos específicos hasta los 36 meses, por lo que podés empezar directamente desde la etapa en la que se encuentra hoy.'
}, {
  q: '¿Qué pasa si lo compro y no era lo que esperaba?',
  a: 'Comprás con total tranquilidad. Tenés 7 días de garantía. Si sentís que el UltraPack no cumple con tus expectativas, nos escribís y te devolvemos el 100% de tu dinero. Sin preguntas y sin vueltas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-5 bg-stone-50" data-id="element-50">
      <div className="text-center mb-10" data-id="element-51">
        <HelpCircle className="w-10 h-10 text-violet-500 mx-auto mb-4" data-id="element-52" />
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-53">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="space-y-3" data-id="element-54">
        {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-55">
            <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-56">
              <span className="font-bold text-gray-900 pr-4" data-id="element-57">{faq.q}</span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-violet-500 flex-shrink-0" data-id="element-58" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-59" />}
            </button>

            {openIndex === index && <div className="px-5 pb-4 text-gray-600 text-sm leading-relaxed" data-id="element-60">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}